module.exports = __webpack_public_path__ + "static/media/logo.divotex.088d086a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.divotex.svg
// module id = 1079
// module chunks = 0